/* @jsxImportSource react */

import * as React from 'react';
import { PriceOldPrice } from '../PriceOldPrice/PriceOldPrice';
import { PriceReductionFlag } from '../PriceReductionFlag/PriceReductionFlag';

export interface PriceDiscountProps extends React.HTMLAttributes<
  Omit<HTMLDivElement, 'className'>
> {
  oldPrice: string;
  oldPriceAriaLabel?: string;
  discount?: string;
  discountAriaLabel?: string;
  /* 
    Defines if the old price can have a strikethrough style, for legal reasons this may not always be allowed.

    As this also can vary between different regions/tenants, the styling itself is handled in the theme CSS.
   */
  allowStrikethrough?: boolean;
}

const PriceDiscount = ({
  oldPrice,
  discount,
  oldPriceAriaLabel,
  discountAriaLabel,
  allowStrikethrough,
  ...props
}: PriceDiscountProps) => (
  <div className="price-discount flex [grid-area:a]" {...props}>
    {oldPriceAriaLabel && <span className="sr-only">{oldPriceAriaLabel}</span>}
    <PriceOldPrice allowStrikethrough={allowStrikethrough}>{oldPrice}</PriceOldPrice>
    {discount && (
      <>
        {discountAriaLabel && <span className="sr-only">{discountAriaLabel}</span>}
        <PriceReductionFlag>{discount}</PriceReductionFlag>
      </>
    )}
  </div>
);

PriceDiscount.displayName = 'Price.Discount';

export { PriceDiscount };
